import { urls } from "../../../business/routes/urls";

/**
 * Every job has its own page at /mc-ops-dashboard/job/<id>?tab=<section>. The
 * "Open in new tab" icon on job cards and in the popup writes these links; the
 * router serves them through McOpsDashboardPage. The sign-in is kept in
 * sessionStorage, which the browser copies into a tab opened with window.open,
 * so the new tab is already signed in.
 */

export const JOB_PAGE_PATH = `${urls.mcOpsDashboard}/job/:jobId`;

export const jobPagePath = (jobId, tab) =>
  `${urls.mcOpsDashboard}/job/${encodeURIComponent(jobId)}?tab=${tab || "s1"}`;

export const jobPageLink = (jobId, tab, location = window.location) =>
  `${location.origin}${jobPagePath(jobId, tab)}`;

export const openJobPage = (jobId, tab) => window.open(jobPageLink(jobId, tab), "_blank");
